import type { ReactNode } from 'react';

type Tone = 'primary' | 'secondary' | 'accent' | 'danger' | 'neutral';

const toneMap: Record<Tone, string> = {
  primary: 'bg-primary-50 text-primary-800 border-primary-200',
  secondary: 'bg-secondary-50 text-secondary-800 border-secondary-200',
  accent: 'bg-accent-50 text-accent-800 border-accent-200',
  danger: 'bg-rose-50 text-rose-700 border-rose-200',
  neutral: 'bg-background-100 text-foreground-700 border-background-300',
};

interface Props {
  children: ReactNode;
  tone?: Tone;
  dot?: boolean;
  className?: string;
}

export default function StatusBadge({ children, tone = 'neutral', dot = true, className = '' }: Props) {
  const dotColor: Record<Tone, string> = {
    primary: 'bg-primary-500',
    secondary: 'bg-secondary-500',
    accent: 'bg-accent-500',
    danger: 'bg-rose-500',
    neutral: 'bg-foreground-400',
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium leading-5 ${toneMap[tone]} ${className}`}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dotColor[tone]}`} />}
      {children}
    </span>
  );
}